module.exports = __webpack_public_path__ + "img/upc.6a36b53c.svg";